import createTheme from '@mui/material/styles/createTheme';
import { alpha } from '@mui/material';
import {
  breakpoints, radii, spacing, heights,
} from '@client/theme/constants';
import { palette } from './colors';
import { typography } from './typography';
import { components } from './components';
import { shadows } from './shadows';

declare module '@mui/material/styles' {
  interface Theme {
    palette: typeof palette;
    heights: {
      BottomAppBar: number;
      MobileAppBar: number;
      DesktopAppBar: number;
    };
    radii: {
      small: string;
      medium: string;
      large: string;
      xlarge: string;
    };
  }

  // allow configuration using `createTheme`
  interface ThemeOptions {
    heights?: {
      BottomAppBar: number;
      MobileAppBar: number;
      DesktopAppBar: number;
    };
    radii?: {
      small: string;
      medium: string;
      large: string;
    };
  }

  interface BreakpointOverrides {
    narrow: true;
    modal: true;
    wideModal: true;
  }
}

// interface declaration merging to add custom mixins
declare module '@mui/material/styles/createMixins' {
  interface Mixins {
    /**
     * Accepts a decimal opacity
     * @param  {string} color Hex or RGB
     * @param  {number} opacity In decimal form between 0 and 1
     */
    alpha: typeof alpha;
  }
}

export const CustomTheme = createTheme({
  breakpoints,
  heights,
  palette,
  radii,
  shadows,
  spacing,
  typography,
  mixins: {
    alpha,
  },
  components: {
    ...components,
  },
});
